module.exports = __webpack_public_path__ + "static/media/call_icon.6f736480.svg";